import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocTeamCustomerLogsDownloadRoute: InvariantJiraRoute = {
	name: 'eoc-team-customer-logs-download',
	path: '/jira/settings/products/ops/jira-service-management-audit-logs/download/:exportUniqueKey',
	exact: true,
};
